export default __webpack_public_path__ + "static/media/aimate-mobile-1.a33b100d.png";